module.exports = __webpack_public_path__ + "img/article-background.e69a56bb.jpg";